<template>
    <svg width="16"
         height="16"
         viewBox="0 0 16 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_11459_9615)">
            <path d="M6.46749 9.1489L8.34741 7.57691M6.46749 9.1489L1.10706 7.23446L14.891 1.87402L11.0622 14.1265L6.46749 9.1489Z"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_11459_9615">
                <rect width="16"
                      height="16"
                      fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconTelegram'
};
</script>
